<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

const BASE_URL = process.env.VUE_APP_EHTALK_URL || 'https://ehtalk.com';

const aberto = ref(false);
const jaAbriu = ref(false);

const chatUrl = computed(() => (jaAbriu.value ? `${BASE_URL}/atendimento` : 'about:blank'));

function abrir() {
  jaAbriu.value = true;
  aberto.value = true;
}

function fechar() {
  aberto.value = false;
}

function alternar() {
  aberto.value ? fechar() : abrir();
}

function aoTeclar(evento) {
  if (evento.key === 'Escape' && aberto.value) fechar();
}

onMounted(() => window.addEventListener('keydown', aoTeclar));
onBeforeUnmount(() => window.removeEventListener('keydown', aoTeclar));
</script>

<template>
  <div class="ehtalk-widget" :class="{ 'ehtalk-widget--open': aberto }">
    <button
      type="button"
      class="ehtalk-widget__btn"
      :aria-label="aberto ? 'Fechar atendimento' : 'Abrir atendimento'"
      :aria-expanded="aberto ? 'true' : 'false'"
      @click="alternar"
    >
      <i class="bi" :class="aberto ? 'bi-x-lg' : 'bi-chat-dots-fill'"></i>
    </button>

    <div class="ehtalk-widget__panel" :hidden="!aberto">
      <div class="ehtalk-widget__header">
        <span>Atendimento</span>
        <button type="button" class="ehtalk-widget__close" aria-label="Fechar" @click="fechar">
          &times;
        </button>
      </div>
      <div class="ehtalk-widget__body">
        <iframe
          class="ehtalk-widget__iframe"
          title="Atendimento Creditall"
          allow="microphone"
          :src="chatUrl"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<style scoped>
.ehtalk-widget {
  position: fixed;
  z-index: 9999;
  right: 24px;
  bottom: 24px;
}

.ehtalk-widget__btn {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 0;
  cursor: pointer;
  background-image: linear-gradient(to bottom, #2f8bff, #1b6dff);
  color: #fff;
  font-size: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  transition: background-image 0.15s ease;
}

.ehtalk-widget__btn:hover {
  background-image: linear-gradient(to bottom, #1b6dff, #1554c7);
}

.ehtalk-widget__panel {
  position: fixed;
  right: 24px;
  bottom: 96px;
  width: 460px;
  height: calc(100vh - 140px);
  max-height: 640px;
  min-height: 420px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transform: translateY(16px) scale(0.98);
  opacity: 0;
  pointer-events: none;
  transition: transform 0.18s ease, opacity 0.18s ease;
}

.ehtalk-widget--open .ehtalk-widget__panel {
  transform: translateY(0) scale(1);
  opacity: 1;
  pointer-events: auto;
}

.ehtalk-widget__header {
  background-image: linear-gradient(to bottom, #2f8bff, #1b6dff);
  color: #fff;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ehtalk-widget__close {
  background: transparent;
  border: 0;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  line-height: 1;
}

/* min-height:0 é obrigatório: sem ele o body estoura o painel e gera rolagem vertical dupla */
.ehtalk-widget__body {
  flex: 1;
  min-height: 0;
}

.ehtalk-widget__iframe {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}

@media (max-width: 640px) {
  .ehtalk-widget__panel {
    right: 0;
    bottom: 0;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    max-height: none;
    min-height: 0;
    border-radius: 0;
  }
}

@media (max-height: 560px) {
  .ehtalk-widget__panel {
    min-height: 0;
    height: calc(100vh - 120px);
  }
}
</style>
